import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthenticationService } from '../../core/services/auth.service';
import { login, loginSuccess, loginFailure, logout, logoutSuccess, Register, RegisterSuccess, RegisterFailure } from './authentication.actions';
import { Router } from '@angular/router';
import { UserProfileService } from 'src/app/core/services/user.service';

@Injectable()
export class AuthenticationEffects {

  Register$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Register),
      exhaustMap(({ registration }) => {
          return this.AuthenticationService.register(registration).pipe(
            map((user) => {
              this.router.navigate(['/auth/login']);
              return RegisterSuccess({ user })
            }),
            catchError((err) => {
              const message = typeof err === 'string'
                ? err
                : err?.error?.msg || err?.error?.message || err?.message || 'Registration failed';
              return of(RegisterFailure({ error: message }));
            })
          )
      })
    )
  );

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      exhaustMap(({ loginForm }) => {
          return this.AuthenticationService.login(loginForm).pipe(
            map((user) => {
              this.router.navigate(['/crm/dashboard']);
              return loginSuccess({ user });
            }),
            catchError((err) => {
              const message = typeof err === 'string'
                ? err
                : err?.error?.msg || err?.error?.message || err?.message || 'Login failed';
              return of(loginFailure({ error: message }));
            })
          )
      })
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      tap(() => {
        // Perform any necessary cleanup or side effects before logging out
      }),
      exhaustMap(() => of(logoutSuccess()))
    )
  );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private AuthenticationService: AuthenticationService,
    private userService: UserProfileService,
    private router: Router) { }
}
